<template>
  <div class="mt-4">
    <v-toolbar width="100%" class="mb-4 mx-auto" elevation="0" outlined>
      <v-icon v-if="icon" class="mr-2">{{ icon }}</v-icon>
      <h4>{{ title }}</h4>
      <v-spacer />
      <slot name="menu" />
    </v-toolbar>

    <v-card flat tile>
      <v-card-text>
        <v-row>
          <v-col class="" cols="6">
            <slot name="search" />
          </v-col>
          <v-col cols="6" class="d-flex justify-end">
            <slot name="controls" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ["title", "icon"],
};
</script>

<style></style>
